import React, { createContext, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';

import { useAuth } from '../../authentication';
import { useGetRolesQuery } from '../hooks';

const RolesContext = createContext();

const RolesProvider = ({ children = null }) => {
  const { accessToken } = useAuth();
  const rolesQuery = useGetRolesQuery(accessToken);

  const value = useMemo(
    () => ({
      roles: rolesQuery.data
    }),
    [rolesQuery.data]
  );

  if (rolesQuery.isInitialLoading) return false;

  return <RolesContext.Provider value={value}>{children}</RolesContext.Provider>;
};

RolesProvider.propTypes = {
  children: PropTypes.node
};

const useRoles = () => useContext(RolesContext);

export { RolesProvider, RolesContext, useRoles };
